"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrthographicCamera = exports.createPerspectiveCamera = void 0;
const three_1 = require("three");
function createPerspectiveCamera() {
    /**
     * The Perspective projection is designed to mimic the way the human eye sees.
     * It is a very common projection mode used when rendering 3D scenes.
     *
     * Note: keep camera frustrum as small as posible for best performance
     */
    const camera = new three_1.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 0.1, 1000);
    // Move the camera a bit back and up, so we can view the scene
    camera.position.set(0, 1, 1);
    camera.lookAt(new three_1.Vector3());
    return camera;
}
exports.createPerspectiveCamera = createPerspectiveCamera;
function createOrthographicCamera() {
    /**
     * The Orthographic projection is like a cube in itself where the perspective
     * remains constant regardless of it's distance from the camera.
     */
    const camera = new three_1.OrthographicCamera(-1, 1, 1, -1, 0.1, 1000);
    // Move the camera a bit back so we can view the scene
    camera.position.set(0, 0, 10);
    return camera;
}
exports.createOrthographicCamera = createOrthographicCamera;
